import { CONTENT_TYPES } from 'core/variables/constant';
import { noShowContentInSmartLink } from './lessonItems';

export function getCurrentReferenceMaterial(currentTest) {
  if (currentTest?.smart_link) {
    return {
      guid: currentTest.smart_link.content?.guid || currentTest.smart_link?.cms_content_guid,
      name: currentTest.smart_link?.name ? currentTest.smart_link?.name : currentTest.smart_link.content?.name,
      content_name: currentTest.smart_link.content?.name || currentTest.smart_link?.name,
      content_guid: currentTest.smart_link.content?.guid || currentTest.smart_link?.cms_content_guid,
      content_type_guid: currentTest.smart_link.content?.type,
      content_url: currentTest.smart_link.content?.url,
    };
  }
  return null;
}

export const hasSmartLink = (type) => {
  return [CONTENT_TYPES.TEST, CONTENT_TYPES.QUESTION].includes(type);
};

export function onClickOpenReferenceMaterial(referenceMaterial) {
  if (referenceMaterial.content_type_guid === CONTENT_TYPES.XAPI) {
    window.open(`/viewerfull-v1/${referenceMaterial.content_guid}`, '_blank');
  } else {
    window.open(`/viewer/${referenceMaterial.content_guid}`, '_blank');
  }
}

/**
 * Aplana los items de una lección. Los items pueden llegar de distintas formas:
 * - como materiales sueltos en el primer nivel (sin sección),
 * - agrupados dentro de una o varias secciones (con items anidados),
 * - o una mezcla de ambos (algunos sueltos y otros dentro de secciones).
 * Recorre recursivamente los items anidados para devolver siempre la lista plana
 * de materiales, independientemente de si están o no dentro de una sección.
 * @param {Array} items - Items de la lección (secciones y/o materiales)
 * @returns {Array} - Lista plana de materiales
 */
function flattenLessonItems(items = []) {
  return items.reduce((resources, item) => {
    if (item?.items?.length > 0) {
      return resources.concat(flattenLessonItems(item.items));
    }
    resources.push(item);
    return resources;
  }, []);
}

export function filterNonEvaluableContents(items = []) {
  const resources = flattenLessonItems(items);
  const nonEvaluableContents = resources.filter(
    (resource) => resource.content_type_guid && !noShowContentInSmartLink(resource.content_type_guid) && !resource?.content_is_teacher_only
  );

  return nonEvaluableContents;
}
